import React, { useEffect, useRef, useCallback, useState } from "react";
import { ReactComponent as LeftArrow } from "../../../../../../assets/arrow-left.svg";
import { MdAdd } from "react-icons/md";
import { useLocationContext } from "../../../../../../contexts/LocationContext"; // Adjust the path as necessary
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet-control-geocoder/dist/Control.Geocoder.css";
import "leaflet-control-geocoder";
import { useStateContext } from "../../../../../../contexts/ThemeContext";
import useLocales from "../../../../../../hooks/useLocales";
import useSettings from "../../../../../../hooks/useSettings";
import { Link, useNavigate } from "react-router-dom";
import MarkerIcon from "../../../../../../assets/MainPage/addBlock/marker.svg";
import LocationFormData from "../../forms/locationForms/LocationFormData";

const LocationList = () => {
  const { locations, setLocations } = useLocationContext();
  const { setActiveMainPageNav } = useStateContext();
  const navigate = useNavigate();
  const mapRef = useRef(null);
  const mapInstance = useRef(null);
  const { translate } = useLocales();
  const { themeDirection } = useSettings();
  const [formDataList, setFormDataList] = useState([]);

  const addMarker = useCallback(
    (location, index) => {
      const customIcon = L.icon({
        iconUrl: MarkerIcon,
        iconSize: [24, 24],
        iconAnchor: [12, 24],
        popupAnchor: [0, -24],
      });

      const marker = L.marker([location.lat, location.lon], {
        icon: customIcon,
        draggable: true,
      }).addTo(mapInstance.current).bindPopup(`
        <b>${location.title}</b><br>
        ${location.address}<br>
        ${location.phone}<br>

        <a href="https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lon}" target="_blank">Get Directions</a>
      `);

      marker.on("dragend", (e) => {
        const { lat, lng } = e.target.getLatLng();
        setLocations(locations.filter((loc, i) => i !== index)); // Remove location from state
      });
    },
    [setLocations, locations]
  );
  const removeMarker = useCallback((location) => {
    // Assuming each marker has a unique ID or some identifiable property
    mapInstance.current.eachLayer((layer) => {
      if (
        layer instanceof L.Marker &&
        layer.options.locationId === location.id
      ) {
        mapInstance.current.removeLayer(layer);
      }
    });
  }, []);

  // Call this function when a location is deleted from the formDataList
  // For example, in a delete button click handler:
  const handleDeleteLocation = (locationId) => {
    setFormDataList(
      formDataList.filter((location) => location.id !== locationId)
    );
    removeMarker({ id: locationId });
  };

  const loadLocationsFromLocalStorage = () => {
    const savedLocations = localStorage.getItem("locations");
    if (savedLocations) {
      setLocations(JSON.parse(savedLocations));
    }
  };

  useEffect(() => {
    loadLocationsFromLocalStorage();
  }, []);

  useEffect(() => {
    if (!mapInstance.current && mapRef.current) {
      mapInstance.current = L.map(mapRef.current).setView([0, 0], 2);
      L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png").addTo(
        mapInstance.current
      );
      // mapInstance.current.on('click', (e) => {
      //   const { lat, lng } = e.latlng;
      //   setLocations([...locations, { lat, lon: lng }]);
      //   saveLocationsToLocalStorage([...locations, { lat, lon: lng }]);
      // });
      mapInstance.current.zoomControl.remove();
      const zoomControl = L.control.zoom({ position: "topright" });
      mapInstance.current.addControl(zoomControl);
      L.Control.geocoder({ position: "topleft" }).addTo(mapInstance.current);
    }
  }, [locations, setLocations]); 

  useEffect(() => {
    locations.forEach((location, index) => {
      addMarker(location, index);
    });
  }, [locations, addMarker]);

  useEffect(() => {
    setActiveMainPageNav(true);
    return () => {
      setActiveMainPageNav(false);
    };
  }, [setActiveMainPageNav]);

  const handleLocation = async (id) => {
    navigate(`/dashboard/component/locationForm`);
  };

  return (
    <>
      <div className=" md:px-0 mt-10 mb-6 px-6 flex sm:flex-row items-start sm:items-center justify-between">
        <div className="flex items-center gap-2">
          <Link
            to={"/dashboard/component"}
            className="flex text-body_copy2 items-center cursor-pointer"
          >
            <div>
              <LeftArrow
                className={`${
                  themeDirection === "rtl" ? "transform -scale-x-100" : ""
                }`}
              />
            </div>
            <p>{translate("cms.location")}</p>
          </Link>
        </div>
        <button
          onClick={() => handleLocation()}
          className="mt-4 sm:mt-0 rounded-full cursor-pointer flex gap-2 lg:gap-[12.5px] p-1 lg:px-[26px] text-white bg-main_color lg:text-small2_b text-small3_b self-start"
        >
          <div className="text-gray-50 -pt-1 lg:text-xl text-lg">
            <MdAdd />
          </div>
          {translate("location.add_location")}
        </button>
      </div>

      <div className="sm:mt-7 md:px-0 mt-10 mb-6 px-6">
        <div className="map-container">
          <div
            ref={mapRef}
            className="h-96 rounded-lg overflow-hidden shadow-lg"
          />
        </div>
        <LocationFormData />
      </div>
    </>
  );
};

export default LocationList;
